import { getRootDomain } from './tenant_utils';

export const getPublicSiteUrl = (slug, path = '') => {
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${window.location.protocol}//${slug}.${getRootDomain()}${port}${path}`;
};
